// externals
import { actions as offerActionTypes } from '@makemydeal/dr-offer-redux';

export type CommonConsumerIdReceivedPayload = {
    commonConsumerId: string;
    commonOrgId?: string;
};

export const commonConsumerIdReceived = ({ commonConsumerId, commonOrgId }: CommonConsumerIdReceivedPayload) => {
    return {
        type: offerActionTypes.CCID_CORGID_UPDATED,
        payload: {
            offer: {
                commonConsumerId,
                commonOrgId
            }
        }
    };
};
